var map = {
	"./facebook.svg": "aaa3",
	"./linkedin.svg": "953d",
	"./logo.svg": "9b19",
	"./media.svg": "a744",
	"./pulse_logo.svg": "9203",
	"./telegram.svg": "7dd3",
	"./threads.svg": "861f",
	"./tiktok.svg": "352b",
	"./twitter.svg": "a3df",
	"./youtube.svg": "73dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";